import { APP_PERMISSIONS } from '@exam-management/permissions';
import { ExamInformation, PassingCriteriaInformation } from '@exam-management/qset-details';
import { Box, Divider, Flex, PaperSection, SectionTitle } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function QSetExamDetailsPage() {
  return (
    <PermissionGuard requiredPermission={[APP_PERMISSIONS.EXAM.QSET.VIEW]}>
      <Box sx={{ padding: (theme) => theme.spacing(6), flex: 1 }}>
        <PaperSection title='Exam Details'>
          <Flex
            sx={(theme) => ({
              flexDirection: 'column',
              padding: theme.spacing(4),
              gap: theme.spacing(8),
            })}
          >
            <SectionTitle title='ข้อมูลชุดข้อสอบ' />
            <ExamInformation />
            <Divider flexItem />
            <SectionTitle title='ข้อมูลเกณฑ์การผ่าน' />
            <PassingCriteriaInformation />
          </Flex>
        </PaperSection>
      </Box>
    </PermissionGuard>
  );
}
